import {TrendViewModel} from "./TrendViewModel";
import {OdometerViewModel} from "../../../../models/OdometerViewModel";
import {VehicleSpecificationsPartViewModel} from "../../../../models/VehicleSpecificationViewModel";

export class ObjectCreateViewModel {

  Id: number;
  Main: ObjectMainPartViewModel = new ObjectMainPartViewModel();
  Settings: ObjectsSettingsPartViewModel = new ObjectsSettingsPartViewModel();
  Trends: TrendViewModel[] = [];
  Odometer: OdometerViewModel = new OdometerViewModel();
  Service: ObjectServicePartViewModel = new ObjectServicePartViewModel();
  VehicleSpecifications: VehicleSpecificationsPartViewModel = new VehicleSpecificationsPartViewModel();

  Events: number[] = [];
  Groups: number[] = [];
  Keys: number[] = [];

  init(data?: any) {
    if (data) {
      this.Main = ObjectMainPartViewModel.fromJS(data["main"]);
      this.Service = ObjectServicePartViewModel.fromJS(data["service"]);
      this.Odometer = OdometerViewModel.fromJS(data["odometer"]);
      this.Settings = ObjectsSettingsPartViewModel.fromJS(data["settings"]);
      this.VehicleSpecifications = VehicleSpecificationsPartViewModel.fromJS(data["vehicleSpecifications"]);

      this.Events = data["events"];
      this.Groups = data["groups"];
      this.Keys = data["keys"];

      let trends = data["trends"];
      if (trends && trends.constructor === Array) {
        for (let item of trends)
          this.Trends.push(TrendViewModel.fromJS(item))
      }
    }
  }

  static fromJS(data: any): ObjectCreateViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ObjectCreateViewModel();
    result.init(data);
    return result;
  }
}

export class ObjectsSettingsPartViewModel {
  DaysToStore: number = 10000;
  MaxPollingPeriod: number = 600;
  MaxSpeed: number = 110;
  MaxDailyMileage: number = 0;
  MaxDailyEngineTime: number = 0;
  ParkingRadius: number = 50;
  MinParkingTime: number = 300;
  ExpenseInKm: number = 0;
  HourlyExpense: number = 0;
  MinDrainSpeed: number = 1;
  MinDrain: number = 0;
  MinRefueling: number = 0;
  MinIdleTime: number = 180_000;
  MinMovingSpeed: number = 3;
  MinSatCount: number = 3;

  init(data?: any) {
    if (data) {
      this.DaysToStore = data["daysToStore"];
      this.MaxPollingPeriod = data["maxPollingPeriod"];
      this.MaxSpeed = data["maxSpeed"];
      this.MaxDailyMileage = data["maxDailyMileage"];
      this.MaxDailyEngineTime = data["maxDailyEngineTime"];
      this.ParkingRadius = data["parkingRadius"];
      this.MinParkingTime = data["minParkingTime"];
      this.ExpenseInKm = data["expenseInKm"];
      this.HourlyExpense = data["hourlyExpense"];
      this.MinDrainSpeed = data["minDrainSpeed"];
      this.MinDrain = data["minDrain"];
      this.MinRefueling = data["minRefueling"];
      this.MinIdleTime = data["minIdleTime"];
      this.MinMovingSpeed = data["minMovingSpeed"];
      this.MinSatCount = data["minSatCount"];
    }
  }

  static fromJS(data: any): ObjectsSettingsPartViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ObjectsSettingsPartViewModel();
    result.init(data);
    return result;
  }
}

export class ObjectServicePartViewModel {
  CreatedAt: number = Date.now();
  Status: number = 1;
  InstalledAt: number = 0;
  Installer: string = "";
  Comment: string = "";
  ServerGroup: string = "";
  PayedTill = 0;

  init(data?: any) {
    if (data) {
      this.CreatedAt = data["createdAt"];
      this.Status = data["status"];
      this.InstalledAt = data["installedAt"];
      this.Installer = data["installer"];
      this.Comment = data["comment"];
      this.ServerGroup = data["serverGroup"];
      this.PayedTill = data["payedTill"];
    }
  }

  static fromJS(data: any): ObjectServicePartViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ObjectServicePartViewModel();
    result.init(data);
    return result;
  }

  public GetStatus(): string
  {
    switch (this.Status)
    {
      case 0:
        return "Blocked";
      case 1:
        return "Active";
      case 15:
        return "Not installed";
      case 10:
        return "Broken";
      case 11:
        return "In service";
      case 255:
        return "Deleted";
    }
    return "";
  }

}





export class ObjectZonesModel {
  Id: number = 0;
  Name: string = "";

  init(data?: any) {
    if (data)
    {
      this.Id = data["id"];
      this.Name = data["name"];
    }
  }

  static fromJS(data: any): ObjectZonesModel {
    data = typeof data === 'object' ? data : {};
    let result = new ObjectZonesModel();
    result.init(data);
    return result;
  }
}
export class ObjectMainPartViewModel {
  Id: number = 0;
  Name: string = "";
  Comment: string = "";
  IMEI: string = "0";
  Phone: string = "";
  Phone1: string = "";
  Model: string = "";
  IconId: number = 0;
  TimeZone: string = "";
  Color: string = "#50f150";
  Flags: string = "";
  Latitude: number;
  Longitude: number;
  Address: string = "";
  InventoryNumber = "";

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Name = data["name"];
      this.Comment = data["comment"];
      this.IMEI = data["imei"];
      this.Phone = data["phone"];
      this.Phone1 = data["phone1"];
      this.Model = data["model"];
      this.IconId = data["iconId"];

      this.Flags = data["flags"];
      this.Color = data["color"];
      this.TimeZone = data["timeZone"];
      this.Latitude = data["latitude"];
      this.Longitude = data["longitude"];
      this.Address = data["address"];
      this.InventoryNumber = data["inventoryNumber"];
    }
  }

  static fromJS(data: any): ObjectMainPartViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ObjectMainPartViewModel();
    result.init(data);
    return result;
  }

  public HasFlag(str: string): boolean {
    return this.Flags.indexOf(str) >= 0;
  }
  public SetFlag(str: string) {
    if (!this.HasFlag(str))
      this.Flags = (this.Flags + " " + str).trim();
  }
  public ResetFlag(str: string) {
    this.Flags = this.Flags.replace(str, "").replace("  ", " ").replace("  ", " ").trim();
  }
}

